interface Props {
  seoTitle: string;
  seoDescription: string;
}

export default function SeoMetaData({ seoTitle, seoDescription }: Props) {
  return (
    <>
      <title>{seoTitle || "BeArt művészetterápia"}</title>
      <meta
        name="description"
        content={
          seoDescription ||
          "BeArt Művészetterápia, Art Coaching, családállítás, coaching, önismeret - művészetterápiás csoportok, egyéni és csoportos alkalmak, szervezeteknek kiégés megelőzés programok, önismereti foglalkozások"
        }
      />
    </>
  );
}
